import styled from 'styled-components';

export default styled.div`
  font: bold 0.75rem sans-serif;
  padding: 1rem;
  text-align: center;
`;
